import {Select} from 'antd';
import React, {SyntheticEvent, useEffect, useState} from "react";
import {SelectionMode} from '@models/index';
import videoFileFetcherHoc from "@hocs/videoFileFetcherHoc";
import {VideoFile} from "@models/videoFile";


const Option = Select.Option;


export interface VideoFileMultiSelectionReturnValue {
  new_files: string[];
  deleted_files: string[];
}

export const videoFileMultiSelectionDefaultReturnValue: VideoFileMultiSelectionReturnValue = {
  new_files: [],
  deleted_files: []
};

type VideoFileSelectionProps = {
  mode: SelectionMode,
  onChange: (value: VideoFileMultiSelectionReturnValue) => void
  selectedVideoFiles: VideoFile[],
  data: VideoFile[],
  onScroll: (e: SyntheticEvent) => void,
  handleSearch: (query: string) => void,
  fetchData: (params: object | null) => void,
  filter?: object,
  isFetched: boolean,
  initialValue: VideoFile[] | VideoFile | null
}


/**
 * This class handle selection of files
 * Use Select fro ant-design because it has on scroll option
 * In terms of lazy loading of data, selected items should bre rendered separated
 * On Change callback return an object from new and deleted files
 * @param props
 * @constructor
 */
const VideoFilesSelection: React.FC<VideoFileSelectionProps> = props => {
  const {handleSearch, disabled=false, onScroll, data = [], initialValue, onChange, fetchData, isFetched, mode = SelectionMode.DEFAULT} = props;
  const defaultValue = mode == SelectionMode.MULTIPLE ? [] : null;
  
  const retrieveValueFromProps = () => {
    if (mode == SelectionMode.MULTIPLE) {
      const returnValue = props.initialValue || [];
      return returnValue.map(item => item.id)
    }
    else {
      return props.initialValue ? props.initialValue.id : null
    }
  };
  
  const [value, setValue] = useState(initialValue ? retrieveValueFromProps() : defaultValue);
  
  useEffect(() => {
    const value = retrieveValueFromProps();
    setValue(value);
  }, [props.initialValue]);
  
  
  /**
   * To handle show selected files before fetch data
   */
  const getData = () => {
    if (mode == SelectionMode.MULTIPLE) {
      let returnData = data;
      props.initialValue.forEach(videoFile => {
        if (returnData.findIndex(opt => opt.id === videoFile.id) === -1) {
          returnData.push(videoFile)
        }
      });
      
      return returnData;
    }
    else {
      return initialValue && !data.find(opt => opt.id == initialValue.id) ? [...data, initialValue] : data;
    }
  };
  
  const onChangeValue = (newValue, option) => {
    setValue(newValue);
    if (mode == SelectionMode.MULTIPLE) {
      const oldValue = props.initialValue.map(cat => cat.id);
      const deleted_files = oldValue.filter(item => newValue.findIndex(id => id === item) === -1);
      const new_files = newValue.filter(item => oldValue.findIndex(id => id === item) === -1);
      props.onChange({
        deleted_files,
        new_files
      });
    }
    else {
      onChange(option.props.videoFile)
    }
  };
  
  const onFocus = () => {
    if (isFetched == false) {
      fetchData({});
    }
  };
  
  return (
    <Select
      showSearch
      disabled={disabled}
      mode={mode}
      value={value}
      defaultActiveFirstOption={false}
      showArrow={true}
      filterOption={false}
      onChange={onChangeValue}
      onFocus={onFocus}
      onSearch={handleSearch}
      onPopupScroll={onScroll}
      notFoundContent={null}
    >
      {getData().map( videoFile =>
        <Option key={videoFile.id} videoFile={videoFile}>{videoFile.title}</Option>
      )}
    </Select>
  );
};

export default videoFileFetcherHoc(VideoFilesSelection);


